import { ExecutionMetadataType, IExecution } from '@pec/aion-ui-core/interfaces/execution';

// The API returns typeId as a number while some payloads use strings — compare numerically.
export const getExecutionMetadataValue = (execution: IExecution, typeId: ExecutionMetadataType): string =>
  execution.executionMetadatas?.find(metadata => Number(metadata.typeId) === Number(typeId))?.data || '';

export const getIncidentStatus = (execution: IExecution): string =>
  getExecutionMetadataValue(execution, ExecutionMetadataType.IncidentStatus);

export const isInitiatedByContractor = (execution: IExecution): boolean => {
  const value = getExecutionMetadataValue(execution, ExecutionMetadataType.InitiatedByContractor)
    .trim()
    .toLowerCase();
  return value === 'true' || value === '1';
};

const normalizeStatus = (status: string): string => status.trim().toLowerCase();

// Incident statuses that require contractor action. Matched case-insensitively because the value is free
// text from the Form.io submission. More will be added as the workflow is fleshed out (CPRO-17684).
export const actionRequiredIncidentStatuses = ['Submitted', 'Under Review'];

// A contractor's own incident sitting at 'Submitted' is waiting on the client, so there is nothing to action
// yet. Once the client replies the status moves on (e.g. 'Under Review') and the CTA appears.
const isAwaitingClientAfterContractorSubmission = (execution: IExecution): boolean =>
  isInitiatedByContractor(execution) && normalizeStatus(getIncidentStatus(execution)) === 'submitted';

export const isActionRequiredIncident = (execution: IExecution): boolean => {
  const status = normalizeStatus(getIncidentStatus(execution));
  return (
    actionRequiredIncidentStatuses.some(actionRequired => normalizeStatus(actionRequired) === status) &&
    !isAwaitingClientAfterContractorSubmission(execution)
  );
};
